module.exports = __webpack_public_path__ + "static/therooftop_03-457e770bb477d80f0536be7f62a6a372.jpg";